
import { Component, Vue } from "vue-property-decorator";

@Component({
  meta: {
    title: "Пользовательское соглашение"
  }
})
export default class TermsOfService extends Vue {}
